// src/data/eventsData.js

const eventsData = [
  {
    id: 1,
    name: "PSL 2026 (Pakistan Super League)",
    date: "27 March 2026",
    time: "7:00 PM",
    location: "Lahore, Karachi, Rawalpindi, Multan, Peshawar",
    desc: "Pakistan’s biggest cricket tournament featuring top local & international players across multiple cities.",
    images: [
      "/assets/imagepsl1.png",
      "/assets/imagepsl2.png",
      "/assets/imagepsl3.png",
    ],
  },


  {
    id: 2,
    name: "Baisakhi Mela Punjab 2026",
    date: "April 2026",
    time: "11:00 AM",
    location: "Lahore & Hasan Abdal",
    desc: "A vibrant cultural and religious festival celebrated at major Gurdwaras with food, traditional music and gatherings.",
    images: [
      "/assets/besakhi2.png",
      "/assets/Baisakhi1.png",
      "/assets/besakhi3.png",
    ],
  },

  {
    id: 3,
    name: "Pakistan Travel Mart 2026",
    date: "03 April 2026",
    time: "9:00 AM",
    location: "Karachi Expo Center",
    desc: "Pakistan’s leading tourism exhibition connecting travel agencies, tour operators, and international tourism brands.",
    images: [
      "/assets/travel1.png",
      "/assets/travel2.png",
      "/assets/travel3.png",
    ],
  },

{
  id: 4,
  name: "Islamabad Food Festival 2026",
  date: "07 April 2026",
  time: "12:00 PM - 10:00 PM",
  location: "Dino Valley, Centaurus Mall, Islamabad",
  desc: "Experience the ultimate culinary celebration featuring 50+ food stalls, live cooking demonstrations by celebrity chefs, fusion cuisine competitions, and authentic Pakistani street food delights.",
  images: [
    "/assets/food1.png",
    "/assets/food2.png",
    "/assets/food3.png",
  ]
},

  {
    id: 5,
    name: "International Conference on Vaccine Research (ICVRICT)",
    date: "April 2026",
    time: "9:30 AM",
    location: "Islamabad",
    desc: "A scientific conference featuring vaccine research, biotechnology innovations, and global healthcare experts.",
    images: [
      "/assets/iv1.png",
       "/assets/iv2.png",
        "/assets/iv3.png",
    ],
  },

  {
    id: 6,
    name: "AI & Robotics Conference 2026",
    date: "April 2026",
    time: "10:00 AM",
    location: "Islamabad / Rawalpindi",
    desc: "A modern academic conference covering Artificial Intelligence, Robotics, Cybersecurity, and emerging technologies.",
    images: [
      "/assets/ai3.png",
      "/assets/ai1.png",
      "/assets/ai2.png",
    ],
  },
];

export default eventsData;